import localhost from "apis/localhost";
import { clearJobQueue } from "slices/app/appSlice";
import { populateErrorMessage } from "slices/app/errorSlice";

const POLL_INTERVAL_MS = 3000;
const DEFAULT_ERROR_MESSAGE = "Failed to generate Excel report";

export const download = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", "true");
  a.click();
};

export const pollJobStatus =
  (jobId, { errorMessage = DEFAULT_ERROR_MESSAGE } = {}) =>
  async (dispatch) => {
    await localhost
      .get("jobStatus", { params: { jobId } })
      .then((jobResp) => {
        if (jobResp.data && (jobResp.data.status === "RUNNING" || jobResp.data.status === "QUEUED")) {
          setTimeout(() => {
            dispatch(pollJobStatus(jobId, { errorMessage }));
          }, POLL_INTERVAL_MS);
        } else if (jobResp.data && jobResp.data.status === "ERROR") {
          dispatch(populateErrorMessage(errorMessage));
          dispatch(clearJobQueue());
        } else {
          download(jobResp.data.jobMetaInfo.file);
          dispatch(clearJobQueue());
        }
      })
      .catch((error) => {
        dispatch(populateErrorMessage(error));
        dispatch(clearJobQueue());
      });
  };

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const awaitJob = async (
  jobId,
  { intervalMs = POLL_INTERVAL_MS, defaultErrorMessage = "Job failed" } = {}
) => {
  for (;;) {
    const { data } = await localhost.get("jobStatus", { params: { jobId } });
    if (data.status === "RUNNING" || data.status === "QUEUED") {
      await sleep(intervalMs);
      continue;
    }
    if (data.status === "ERROR") {
      const message = data.jobMetaInfo?.message || defaultErrorMessage;
      throw new Error(message);
    }
    return data.jobMetaInfo;
  }
};
